module.exports = __webpack_public_path__ + "img/ofertaComodidad.6ed4b420.svg";